<script setup lang="ts">
import AnnouncementPlace from "~/components/index/AnnouncementPlace.vue";

usePageTitle("Главная");
</script>

<template>
  <div class="flex flex-col gap-5 lg:gap-20 px-0">
    <HeroCarousel />
    <div class="px-4 sm:px-8 lg:px-12">
      <AnnouncementPlace />
    </div>
  </div>
</template>
